import comPartner from './com-partner'

export default comPartner
